/*
 * @Author: qian.tang
 * @Date: 2023-09-21 10:30:26
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2023-11-30 09:27:59
 * @FilePath: \itrazo-portal-dev\src\components\QRModal\index.tsx
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import React, { useEffect, useState } from 'react'
import QRCode from "react-qr-code";
import ReactToPrint from 'react-to-print';
import SimpleButton from 'components/GlobalButtons/SimpleButton'
import GlobalModal from 'components/GlobalModal'
import { getBizCode } from 'utilities/Functions/GlobalHelperFunctions';

type Props = {
  open: boolean
  setIsQRModalOpen: Function
  modalData: any
}

const QRModal = (props: Props) => {
  const { open, setIsQRModalOpen, modalData } = props
  console.log(modalData)
  const componentRef = React.useRef(null);

  const [value, setValue] = useState('')

  useEffect(() => {
    if (modalData?.qr_code) {
      setValue(modalData?.qr_code)
    }
    if (modalData?.QRcode) {
      console.log('QRcode', modalData)
      setValue(modalData?.QRcode)
    }

  }, [modalData, modalData?.qr_code, modalData?.QRcode, open])


  console.log('QRModal props', props)

  const closeQR = () => {
    setIsQRModalOpen(false);

  };

  return (
    <GlobalModal
      title="QR Code"
      open={open}
      onCancel={(e: MouseEvent) => {
        e.preventDefault()
        closeQR()
      }}
      footer={[
        <ReactToPrint
          key='0'
          trigger={() => (<SimpleButton
            id='modal-btn-width-regular'
            key="submit"
            text='Print'
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              // handleModalSubmit()
            }}
          />)}
          content={() => {
            console.log('  content', componentRef.current)
            return componentRef.current
          }}
          documentTitle={`QR code`}
        />

      ]}
    >
      {/* <ReactToPrint
        trigger={() => <PrinterOutlined style={{ fontSize: '20px' }} />}
        content={() => {
          console.log('  content', componentRef.current)
          return componentRef.current
        }}
        documentTitle={`QR code`}
      /> */}

      <div style={{ height: "auto", margin: "20px auto", maxWidth: '45%', width: "100%" }} ref={componentRef}>        
        {value ? (
          <QRCode
            size={256}
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            value={modalData.QRcode ? `${process.env.REACT_APP_SCAN_WEB_APP_BASE}scan/${getBizCode()}/${modalData.asset_ID}` : value}
            // value={value}
            viewBox={`0 0 256 256`}
          />
        ) : null}

      </div>

    </GlobalModal>
  )
}

export default QRModal